import { useAnalytics } from 'hooks/analytics/useAnalytics'
import { useLogger } from 'hooks/useLogger'
import { useCallback, useState } from 'react'

import { useDisplayMedia } from './useDisplayMedia'

export function useScreenShare() {
  const { analytics } = useAnalytics()
  const logger = useLogger()
  const [sharingScreen, setSharingScreen] = useState(false)

  const shareScreen = useCallback(() => {
    analytics.logEvent('tele_videochamadas_compartilhar_tela')
    logger.info('Iniciando compartilhamento de tela')
    setSharingScreen(true)
  }, [analytics, logger])
  const stopSharingScreen = useCallback(() => setSharingScreen(false), [])
  const handleError = useCallback(() => setSharingScreen(false), [])

  const { stream: displayStream } = useDisplayMedia({
    audio: false,
    video: sharingScreen,
    onStreamClose: stopSharingScreen,
    onError: handleError,
  })

  return {
    sharingScreen: sharingScreen && !!displayStream,
    displayStream,
    shareScreen,
    stopSharingScreen,
  }
}
